import { render, staticRenderFns } from "./PayOrRefundSuccessDialog.vue?vue&type=template&id=8d0ae240&scoped=true"
import script from "./PayOrRefundSuccessDialog.vue?vue&type=script&lang=js"
export * from "./PayOrRefundSuccessDialog.vue?vue&type=script&lang=js"
import style0 from "./PayOrRefundSuccessDialog.vue?vue&type=style&index=0&id=8d0ae240&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d0ae240",
  null
  
)

export default component.exports